/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { PageTitle } from '../../../../../_metronic/layout/core'
import { Datatable } from '../../../../components/Datatable/Datatable'
import { Button } from '../../../../components/Button/Button'
import { Input } from '../../../../components/Input/Input'
import { Loading } from '../../../../components/Loading/Loading'
import { GET, POST, PUT } from '../../../../services/api'
import { toDate, toDateTime } from '../../../../utils/formater'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import { ModalWrapper } from '../../../../components/Modals/General/ModalWrapper/ModalWrapper'
import { KTSVG } from '../../../../../_metronic/helpers'
import useModals from '../../../../hooks/useModals'
import Swal from 'sweetalert2'
import { i18n } from '../../../../translate/i18n'
import useAuth from '../../../../hooks/useAuth'
import { BreadCrumbs } from '../../../../components/BreadCrumbs/breadCrumbrs'
import { verifySynkar } from '../../../../functions/integrations'
import { AudioFunction } from '../../../../components/Audio/audio'
import styles from './index.module.css'
import getIntegrations from '../../../../utils/printOrder'
import { Buffer } from 'buffer'
const qz = require('qz-tray')

type CustomerAddressType = {
  city: string
  district: string
  state: string
  street: string
  zipCode: string
  number: string
  extra: string
}

type CustomerType = {
  id: number
  name: string
  customerAddress: CustomerAddressType
}

type LocationType = {
  id: number
  name: string
  code: string
}

type StatusType = {
  id: number
  name: string
  slug: string
  order: number
}

type OrderResponseType = {
  id: number
  orderidExt: string
  customer: CustomerType
  created: string
  location: LocationType
  total: number
  status: StatusType[]
  products: any[]
  statusId: number
  content: any
}

type OrderType = {
  checkbox?: string
  id: string
  orderidExt: string
  customer: string
  location: string
  created: string
  total: number
  status: string
  payment: string
}

type ModalityResponseType = {
  id: number
  name: string
  type: string
  status: boolean
  description: string | null
  code: string
}

type StatusResponseType = {
  id: number
  name: string
  slug: string
  order: number
  colorSetting: {
    background: string
  }
  pluginspaceId: number
  plugintypeId: number
  externalCorrelation: Record<string, string>
  displayStatusWebapp: boolean
  messageStatus: string
  activeSms: boolean
}

type Option = {
  icon: string
  title: string
  action: (item: any) => Promise<void>
}

const jsonStyle = {
  propertyStyle: { color: 'grey' },
  stringStyle: { color: 'white' },
  numberStyle: { color: 'white' },
  booleanStyle: { color: 'white' },
  style: { color: 'white' },
}

const PedidosContent: FC = () => {
  const navigate = useNavigate()
  const { loginInfo } = useAuth()
  const { wrapperModal, showWrapperModal, closeWrapperModal } = useModals()
  const [loading, setLoading] = useState(false)
  const today = moment().format('YYYY-MM-DD')
  const [startDate, setStartDate] = useState(today)
  const [finalDate, setFinalDate] = useState(today)
  const [modality, setModality] = useState(0)
  const [payment, setPayment] = useState('all')
  const [status, setStatus] = useState(0)
  const [newStatus, setNewStatus] = useState(0)
  const [orders, setOrders] = useState<OrderType[]>([])
  const [orderId, setOrderId] = useState(0)
  const [ordersNoFormated, setOrdersNoFormated] = useState<any[]>([])
  const [header, setHeader] = useState([])
  const [typeModal, setTypeModal] = useState<'cancel' | 'change' | 'print'>('cancel')
  const [limitOrderChange, setLimitOrderChange] = useState(Infinity)
  const [canGetOrders, setCanGetOrders] = useState(false)
  const [differentOrders, setDifferentOrders] = useState<any[]>([])
  const { handlePlay } = AudioFunction()
  const [clearsaleOrder, setClearsaleOrder] = useState<any | null>(null)
  const [canPrint, setCanPrint] = useState(false)
  const [limitDate, setLimitDate] = useState<string>()
  const [modalityOptions, setModalityOptions] = useState([
    {
      value: 0,
      select: 'Todos',
    },
  ])
  const [statusOptions, setStatusOptions] = useState([
    {
      value: 0,
      select: 'Todos',
    },
  ])
  const [paymentOptions] = useState([
    {
      value: 'all',
      select: 'Todos',
    },
    {
      value: 'paymentOffline',
      select: 'Pagamento na entrega',
    },
    {
      value: 'pix',
      select: 'Pix',
    },
    {
      value: 'card',
      select: 'Cartão de Crédito',
    },
  ])
  const [selectedItem, setSelectedItem] = useState<any>(null)
  const [isPrinting, setIsPrinting] = useState(false)
  const [resultPrint, setResultPrint] = useState<{ success: boolean; message: string } | null>(null)
  const [printer, setPrinter] = useState<string>('')
  const [isSwalActive, setIsSwalActive] = useState(false)
  let accumulatedOrderIds: any[] = []

  const removeHTMLTags = (html: string) => {
    return html.replace(/<\/?[^>]+(>|$)/g, '') // Remove as tags HTML
  }

  const cleanSpace = (text: string) => {
    return text
      .replace(/\s+/g, ' ') // Substitui múltiplos espaços por um único espaço
      .replace(/^\s+|\s+$/g, '') // Remove espaços no começo e no final
      .replace(/\n/g, ' ') // Substitui quebras de linha por um espaço
      .replace(/\r/g, '') // Remove '\r' se houver
  }

  const cleanItem = async (item: any) => {
    return {
      ...item,
      checkbox: cleanSpace(removeHTMLTags(item.checkbox)), // Limpa espaços, quebras de linha e tags HTML
      id: cleanSpace(removeHTMLTags(item.id)),
      orderidExt: cleanSpace(removeHTMLTags(item.orderidExt)),
      customer: cleanSpace(removeHTMLTags(item.customer)),
      location: cleanSpace(removeHTMLTags(item.location)),
      status: cleanSpace(removeHTMLTags(item.status)),
      payment: cleanSpace(removeHTMLTags(item.payment)),
    }
  }

  const openPrintModal = async (item: any) => {
    const cleanedItem = await cleanItem(item)
    setSelectedItem(cleanedItem)
    setTypeModal('print')
    showWrapperModal(`${i18n.t('order_print.print')} ${' '}${cleanedItem.id || ''}`)
  }

  const [options, setOptions] = useState<Option[]>([])

  const connectQZ = () => {
    return new Promise((resolve, reject) => {
      qz.websocket
        .connect()
        .then(() => resolve('Conectado ao QZ Tray'))
        .catch((error: any) => reject(`Erro na conexão com QZ Tray: ${error}`))
    })
  }

  const printData = async (orderIds?: any[]) => {
    setIsPrinting(true)
    setResultPrint(null)

    try {
      if (!orderIds || orderIds.length === 0) {
        const orderId = selectedItem.id.split('#')[1]

        const print = await POST('order-printer/print-order', {
          orderId,
        })

        if (print.success === true) {
          setResultPrint({ success: true, message: print.message })
        } else {
          setResultPrint({ success: false, message: print.message })
        }

        const dataBuffer = Buffer.from(print.data, 'utf8')
        const dataToSend = dataBuffer.toString('utf8')

        await connectQZ()

        qz.printers
          .find(printer)
          .then((printer: any) => {
            const config = qz.configs.create(printer)
            const data = [
              '\x1B\x40', // Inicializa a impressora
              dataToSend,
              '\x1D\x56\x00', // Comando para cortar
            ]
            return qz.print(config, data)
          })
          .then(() => {
            setResultPrint({ success: true, message: 'Solicitação enviada com sucesso' })
          })
          .catch((error: any) => {
            setResultPrint({ success: false, message: 'Impressora não encontrada.' })
          })
          .finally(() => {
            qz.websocket.disconnect()
          })
      } else {
        for (const orderId of orderIds) {
          const print = await POST('order-printer/print-order', {
            orderId,
          })

          if (print) {
            const dataBuffer = Buffer.from(print.data, 'utf8')
            const dataToSend = dataBuffer.toString('utf8')

            await connectQZ()

            try {
              await qz.printers.find(printer).then((printer: any) => {
                const config = qz.configs.create(printer)
                const data = [
                  '\x1B\x40', // Inicializa a impressora
                  dataToSend,
                  '\x1D\x56\x00', // Comando para cortar
                ]
                return qz.print(config, data)
              })
            } catch (error) {
              console.error('Erro na impressão do pedido', error)
            } finally {
              qz.websocket.disconnect()
            }
          } else {
            console.error('Erro na impressão do pedido')
          }
        }
      }
    } catch (e) {
      console.log(e)
      setResultPrint({ success: false, message: 'Erro na impressão. Tente novamente.' })
    } finally {
      setIsPrinting(false)
    }
  }

  // const sound = new Howl({
  //   src: [alarme],
  //   volume: volume, // volume do áudio (0 a 1)
  //   loop: false, // se o áudio deve repetir
  //   autoplay: false, // se o áudio deve iniciar automaticamente
  //   preload: true, // se o áudio deve ser pré-carregado

  //   onend: () => {
  //     console.log('tocando')
  //   },
  //   onloaderror: (error: any) => {
  //     console.error('Erro ao carregar áudio:', error);
  //   }
  // });

  const mapPayment = (flag: string) => {
    switch (flag) {
      case 'paymentOffline':
        return 'Pagamento na Entrega'
      case 'payOffline':
        return 'Pagamento na Entrega'
      case 'pix':
        return 'Pix'
      default:
        return 'Cartão de Crédito'
    }
  }

  const searchOrders = async () => {
    try {
      setLoading(true)
      setCanGetOrders(false)
      if (finalDate === '' || startDate === '') {
        Swal.fire({
          title: 'Erro!',
          text: i18n.t(`reports.invalid_data`),
          icon: 'warning',
          confirmButtonText: 'Ok',
        })
        return
      }
      const res = await searchOrdersApi()
      setOrders(res ?? [])
      setCanGetOrders(true)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const getOrderId = (id: string) => {
    const match = id.match(/#(\d+)/)
    return match ? match[1] : null
  }

  const getOrdersTimeOut = async () => {
    const overlayPrint = document.createElement('div')
    overlayPrint.style.position = 'fixed'
    overlayPrint.style.top = '0'
    overlayPrint.style.left = '0'
    overlayPrint.style.width = '100%'
    overlayPrint.style.height = '100%'
    overlayPrint.style.backgroundColor = 'rgba(0, 0, 0, 0.5)' // Filtro cinza transparente
    overlayPrint.style.zIndex = '9998'

    try {
      if (canGetOrders) {
        const res = await searchOrdersApi()
        if (res) {
          setOrders((prevOrders) => {
            const newDifferentOrders = res.filter((order: any) => {
              return !prevOrders.some(
                (existingOrder: any) => existingOrder.orderidExt === order.orderidExt
              )
            })

            if (newDifferentOrders.length > 0) {
              handlePlay()

              if (!isSwalActive && canPrint) {
                setIsSwalActive(true)

                const newOrderIds = newDifferentOrders.map((order) => getOrderId(order.id))
                accumulatedOrderIds = [...accumulatedOrderIds, ...newOrderIds]

                Swal.fire({
                  icon: 'info',
                  title: 'Confirmar Impressão',
                  html: `
                    O QZ Tray solicitará sua permissão para estabelecer a conexão. 
                    Clique em "Allow" no alerta que será exibido para prosseguir com a impressão. 
                    <br><br>
                    Deseja continuar com a impressão de todos os pedidos?
                    <br><br>
                    <strong>Total de Pedido(s): ${accumulatedOrderIds.length}</strong>
                  `,
                  confirmButtonText: 'Imprimir',
                  showCancelButton: true,
                  cancelButtonText: 'Cancelar',
                  customClass: {
                    popup: styles['swal-popup'],
                  },
                }).then(async (userConfirmation) => {
                  if (userConfirmation.isConfirmed) {
                    document.body.appendChild(overlayPrint)

                    await printData(accumulatedOrderIds)

                    document.body.removeChild(overlayPrint)

                    accumulatedOrderIds = [] // Resetando o array
                  } else {
                    accumulatedOrderIds = [] // Resetando o array
                  }

                  setIsSwalActive(false)
                })
              }

              return [...newDifferentOrders, ...prevOrders]
            }

            return prevOrders
          })
        }
      }
    } catch (error) {
      console.log(error)
    } finally {
      document.body.contains(overlayPrint) && document.body.removeChild(overlayPrint)
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      getOrdersTimeOut()
    }, 30000)

    return () => clearInterval(interval)
  }, [canGetOrders])

  const searchOrdersApi = async () => {
    try {
      const resOrders = await POST('/orders/filter-admin_v2', {
        startDate: `${startDate}T00:00:00`,
        finalDate: `${finalDate}T23:59:59`,
        statusId: parseInt(status.toString()),
        locationId: parseInt(modality.toString()),
        payment,
      })

      const resOrdersReverse = [...resOrders.data].reverse()

      setOrdersNoFormated(
        resOrdersReverse.map((o: any, index: number) => ({
          ...o,
          orderidExtNormal: `${o.orderidExt}-${index}`,
        }))
      )

      const newOrders: OrderType[] = resOrdersReverse.map((order: OrderResponseType) => {

        /*Por padrao usar o numero pequeno da integracao, caso nao tenha usar o nosso. */
        const codigoPedido = order.content && order.content.externalCodeERP ? `${order.content.externalCodeERP}` : order.id;



        let colorStatus = ''
        const statusOrder = order.status.find((status) => status.id === order.statusId)
        switch (statusOrder ? statusOrder.order : 1) {
          case 1:
            colorStatus = '#4DD0E1'
            break
          case 2:
            colorStatus = '#8D6E63'
            break
          case 3:
            colorStatus = '#7E57C2'
            break
          case 4:
            colorStatus = '#2E7D32'
            break
          default:
            colorStatus = '#AD1457'
            break
        }

        let total = order.total //order.products.reduce((acc: number, item: any) => acc + (item.price * item.quantity), 0)

        if (order.content && order.content.discountPaymentType) {
          const discountPaymentType = order.content.discountPaymentType
          if (discountPaymentType.type === 'percentage') {
            const discountValue = parseFloat(discountPaymentType.discountValue) || 0

            total = Math.round(order.total - (order.total * discountValue) / 100)
          } else {
            total = order.total - parseFloat(discountPaymentType.discountValue) * 100
          }
        }

        const statusHtml = `
        <div style="display: flex; flex-direction:row; align-items: center; font-size: 12px; color: ${colorStatus}">
          <div style="border: 1px solid ${colorStatus}; border-radius: 100%; width: 16px; height: 16px; text-align: center; display: flex; flex-direction: row; align-items: center; justify-content: center">
            ${statusOrder ? statusOrder.order : ''}
          </div>
          <p class="mb-0" style="margin-left: 1em">${statusOrder ? statusOrder.name : ''}</p>
        </div>
        `

        let colorLocation = '#4DD0E1'
        if (order.location && order.location.code === 'delivery') {
          colorLocation = '#7E57C2'
        }
        const locationHtml = `
        <div style="display: flex; flex-direction:row; align-items: center; color: ${colorLocation}">
          ${order.location && order.location.code === 'delivery'
            ? '<svg xmlns="http://www.w3.org/2000/svg" fill="#7E57C2" width="20" height="20" viewBox="0 0 640 512"><!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M280 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h57.7l16.4 30.3L256 192l-45.3-45.3c-12-12-28.3-18.7-45.3-18.7H64c-17.7 0-32 14.3-32 32v32h96c88.4 0 160 71.6 160 160c0 11-1.1 21.7-3.2 32h70.4c-2.1-10.3-3.2-21-3.2-32c0-52.2 25-98.6 63.7-127.8l15.4 28.6C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L418.2 128H480c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H459.6c-7.5 0-14.7 2.6-20.5 7.4L391.7 78.9l-14-26c-7-12.9-20.5-21-35.2-21H280zM462.7 311.2l28.2 52.2c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-28.2-52.2c2.3-.3 4.7-.4 7.1-.4c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-15.5 5.5-29.7 14.7-40.8zM187.3 376c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c26.9 0 49.9 16.5 59.3 40h66.4C242.5 268.8 190.5 224 128 224C57.3 224 0 281.3 0 352s57.3 128 128 128c62.5 0 114.5-44.8 125.8-104H187.3zM128 384c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"/></svg>'
            : '<svg xmlns="http://www.w3.org/2000/svg" fill="#4DD0E1" width="20" height="20" viewBox="0 0 640 512"><!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M36.8 192H603.2c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM64 224V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V384 224H320V384H128V224H64zm448 0V480c0 17.7 14.3 32 32 32s32-14.3 32-32V224H512z"/></svg>'
          }
          <p class="mb-0" style="margin-left: 1em">${order.location ? order.location.name : 'Mesa/Comanda'
          }</p>
        </div>
        `

        const customerHtml = `
        <div style="display: flex; flex-direction:column;">
          <p class='mb-0'>${order.customer ? order.customer.name : '-/-'}</p>
          ${order.customer && order.customer.customerAddress
            ? `
            <p class='mb-0 text-muted'>
              ${order.customer.customerAddress.street} 
              ${order.customer.customerAddress.number
              ? ', ' + order.customer.customerAddress.number
              : ''
            } 
              ${order.customer.customerAddress.extra ? order.customer.customerAddress.extra : ''} 
            </p>
            <p class='mb-0 text-muted'>
              ${order.customer.customerAddress.city} 
              ${order.customer.customerAddress.state} 
              ${order.customer.customerAddress.zipCode
              ? ' - ' +
              order.customer.customerAddress.zipCode.substring(0, 5) +
              '-' +
              order.customer.customerAddress.zipCode.substring(5, 8)
              : ''
            } 
            </p>`
            : ``
          }
        </div>
        `

        let payment = ''
        if (
          order.content &&
          order.content.dataGateway &&
          order.content.dataGateway.flagIdentifier
        ) {
          payment = mapPayment(order.content.dataGateway.flagIdentifier)
        }

        order.orderidExt = `
        <a href="${window.location.href}/${order.id}" target="_blank">
          #${codigoPedido}
        </a>
        `
        const orderId = `
        <a href="${window.location.href}/${order.id}" target="_blank">
          #${codigoPedido}
        </a>
        `

        const checkbox = `
          <div class='mt-4'>
            <label class='form-check'>
              <input
                type='checkbox'
                class='form-check-input checkbox-order'
                id='ordercheck-${order.id}'
              />
            </label>
          </div>
        `

        return {
          checkbox: checkbox,
          id: orderId,
          orderidExt: order.orderidExt,
          customer: customerHtml,
          location: locationHtml,
          created: order.created,
          total: total,
          status: statusHtml,
          payment,
        }
      })
      return newOrders
    } catch (e) {
      console.log(e)
    }
  }

  const getModalities = async () => {
    try {
      setLoading(true)
      const modalitiesRes = await GET('/location')
      const filterModalities = modalitiesRes.data.filter(
        (modalityItem: ModalityResponseType) => modalityItem.type !== 'address'
      )
      const newModalityOptions = filterModalities.map((modalityItem: ModalityResponseType) => ({
        value: parseInt(modalityItem.id.toString()),
        select: modalityItem.name,
      }))
      setModalityOptions([...modalityOptions, ...newModalityOptions])
    } catch (e) {
      console.log(e)
    }
  }

  const closeModal = () => {
    closeWrapperModal()
  }

  const changeMultipleStatus = async () => {
    try {
      let orderIds: number[] = []
      orders.forEach((o) => {
        const idCheckboxNoFormated = o.checkbox?.split("id='")[1]
        if (idCheckboxNoFormated) {
          const idCheckbox = idCheckboxNoFormated.split("'")[0]
          if (idCheckbox) {
            const item: any = document.getElementById(idCheckbox)
            if (item && item.checked) {
              orderIds.push(parseInt(idCheckbox.split('ordercheck-').join('')))
            }
          }
        }
      })

      setLoading(true)
      const resultChange = await POST('/orders/change-multiple-status', {
        statusId: parseInt(newStatus.toString()),
        orderIds,
        orderIdsExt: ordersNoFormated
          .filter((o) => orderIds.includes(o.id))
          .map((o) => o.orderidExtNormal),
        contents: ordersNoFormated.filter((o) => orderIds.includes(o.id)).map((o) => o.content),
      })
      setLoading(false)
      if (resultChange.success) {
        Swal.fire({
          icon: 'success',
          title: 'Sucesso',
          text: 'Pedidos atualizados com sucesso',
        }).then(async () => await searchOrders())
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Falha ao atualizar pedidos',
        })
      }
    } catch (e) {
      setLoading(false)
      console.log(e)
    } finally {
      closeModal()
    }
  }

  const getStatus = async () => {
    try {
      setLoading(true)
      const statusRes = await GET('/status')
      const newStatusOptions = statusRes.data.filter((status: StatusResponseType) => status.displayStatusWebapp === true).map((statusItem: StatusResponseType) => ({
        value: parseInt(statusItem.id.toString()),
        select: statusItem.name,
      }))
      setStatusOptions([...statusOptions, ...newStatusOptions])
    } catch (e) {
      console.log(e)
    }
  }

  const cancelOrder = async () => {
    try {
      const orderToCancel = ordersNoFormated.find((order) => order.id === orderId)
      if (!orderToCancel) {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Falha ao encontrar pedido ao cancelá-lo',
        })
        return
      }
      setLoading(true)
      const resStatus = await GET('/status')
      const statusCanceled = resStatus.data.find((status: StatusType) => status.slug === 'canceled')
      if (!statusCanceled) {
        setLoading(false)
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Falha ao encontrar status do pedido',
        })
        return
      }
      if (orderToCancel.status.find((status: StatusType) => status.slug === 'canceled')) {
        setLoading(false)
        Swal.fire({
          icon: 'warning',
          title: 'Atenção!',
          text: 'Pedido já foi cancelado.',
        })
        return
      }
      if (
        !orderToCancel.id ||
        !orderToCancel.content ||
        !orderToCancel.content.dataGateway ||
        !orderToCancel.content.dataGateway.pluginconfig_id
      ) {
        setLoading(false)
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Pedido com dados faltantes, impossível cancelá-lo',
        })
        return
      }
      const resOrders = await PUT(`/orders/change-status/${orderToCancel.id}`, {
        statusId: statusCanceled.id,
        dataGateway: orderToCancel.content.dataGateway,
        gatewayId: orderToCancel.content.dataGateway.pluginconfig_id,
        statusSlug: 'canceled',
      })
      setLoading(false)
      if (resOrders.success) {
        Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          text: 'Pedido cancelado com sucesso!',
        }).then(async () => await searchOrders())
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Falha ao cancelar o pedido.',
        })
      }
    } catch (e: any) {
      setLoading(false)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: e ? e : 'Falha ao cancelar o pedido.',
      })
      console.log(e)
    }
  }

  function configHeader(statusPrint: boolean) {
    const header: any = []

    if (loginInfo.plugintype === 'food') {
      header.push(
        { key: '', value: 'checkbox', type: 'html' },
        { key: i18n.t(`reports.order_number`), value: 'id', type: 'html' },
        { key: i18n.t(`reports.date`), value: 'created', type: 'datetime' },
        { key: i18n.t(`reports.consumer`), value: 'customer', type: 'html' },
        { key: i18n.t(`reports.modality`), value: 'location', type: 'html' },
        { key: i18n.t(`reports.payment`), value: 'payment', type: 'default' },
        { key: i18n.t(`reports.total_value`), value: 'total', type: 'money' },
        { key: 'Status', value: 'status', type: 'html' },
        statusPrint && { key: 'Ações', value: 'acoes', type: '', noOrder: true }
      )
    } else {
      header.push(
        { key: '', value: 'checkbox', type: 'html' },
        { key: i18n.t(`reports.order_number`), value: 'orderidExt', type: 'html' },
        { key: i18n.t(`reports.date`), value: 'created', type: 'datetime' },
        { key: i18n.t(`reports.consumer`), value: 'customer', type: 'html' },
        { key: i18n.t(`reports.modality`), value: 'location', type: 'html' },
        { key: i18n.t(`reports.payment`), value: 'payment', type: 'default' },
        { key: i18n.t(`reports.total_value`), value: 'total', type: 'money' },
        { key: 'Status', value: 'status', type: 'html' }
      )
    }

    setHeader(header)
  }

  const filterOrdersStatus = () => {
    const ordersFiltered = orders.filter((o) => {
      const idCheckboxNoFormated = o.checkbox?.split("id='")[1]
      if (idCheckboxNoFormated) {
        const idCheckbox = idCheckboxNoFormated.split("'")[0]
        if (idCheckbox) {
          const item: any = document.getElementById(idCheckbox)
          if (item && item.checked) {
            return true
          }
        }
      }
      return false
    })
    return ordersFiltered
  }

  const getLimitSynkar = async () => {
    const synkarIntegration = await verifySynkar()
    if (synkarIntegration && synkarIntegration.content && synkarIntegration.content.able === '1') {
      setLimitOrderChange(
        synkarIntegration.content.limitChangeOrder &&
          parseInt(synkarIntegration.content.limitChangeOrder)
          ? parseInt(synkarIntegration.content.limitChangeOrder)
          : 10
      )
    }
  }

  const getStatusPrinter = async () => {
    const integrations = await getIntegrations(loginInfo)
    let statusPrint

    if (integrations.length === 0 || integrations[0].data[0].content.enabled === '0') {
      setCanPrint(false)
      statusPrint = false
    } else {
      setCanPrint(true)
      statusPrint = true
      const printerIntegration = await getIntegrations(loginInfo)
      setPrinter(printerIntegration[0].data[0].content.printer_model)
      setOptions([
        {
          icon: 'fas fa-print',
          title: i18n.t('order_print.print_text'),
          action: (item: any) => openPrintModal(item),
        },
      ])
    }
    configHeader(statusPrint)
  }

 const handleStartDateChange = (newStartDate: string) => {
    if (!newStartDate) {
      setStartDate('')
      return
    }


    const newStart = moment(newStartDate)
    const maxEnd = newStart.clone().add(3, 'months')

    if (moment(finalDate).isAfter(maxEnd) || moment(finalDate).isAfter(today)) {
      setFinalDate(moment.min(maxEnd, moment(today)).format('YYYY-MM-DD'))
    }

    setStartDate(newStartDate)
  }

  const handleFinalDateChange = (newFinalDate: string) => {
    if (!newFinalDate) {
      setFinalDate('')
      return
    }

    const newEnd = moment(newFinalDate)
    const minStart = newEnd.clone().subtract(3, 'months')

    if (newEnd.isAfter(today)) return

    if (moment(startDate).isBefore(minStart)) {
      setStartDate(minStart.format('YYYY-MM-DD'))
    }

    setFinalDate(newFinalDate)
  }

  const init = async () => {
    setLoading(true)
    await getStatusPrinter()
    await getLimitSynkar()
    await getModalities()
    await getStatus()
    await searchOrders()
  }

  useEffect(() => {
    init()
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>
                  {i18n.t(`reports.order_list`)}
                </span>
                <BreadCrumbs />
              </h3>
            </div>
            <div className='card-body'>
              <div className='w-100 mb-5'>
                <div className='d-flex flex-row flex-wrap align-items-end gap-4'>
                  <Input
                    inputAttr={{ type: 'date' }}
                    label={i18n.t(`reports.first`)}
                    value={startDate}
                    change={(value: string) => setStartDate(value)}
                    maxLength={finalDate}
                  />
                  <div>
                    <Input
                      inputAttr={{ type: 'date' }}
                      label={i18n.t(`reports.end`)}
                      value={finalDate}
                      change={(value: string) => setFinalDate(value)}
                      minLength={startDate}
                    />
                  </div>
                  <div>
                    <Input
                      inputAttr={{
                        type: 'select',
                      }}
                      label={i18n.t(`reports.modality`)}
                      options={modalityOptions}
                      placeholder={i18n.t(`reports.modality`)}
                      value={modality}
                      change={(value: any) => setModality(value)}
                    />
                  </div>
                  <div>
                    <Input
                      inputAttr={{
                        type: 'select',
                      }}
                      options={paymentOptions}
                      label={i18n.t(`reports.payment`)}
                      placeholder={i18n.t(`reports.payment`)}
                      value={payment}
                      change={(value: any) => setPayment(value)}
                    />
                  </div>
                  <div>
                    <Input
                      inputAttr={{
                        type: 'select',
                      }}
                      options={statusOptions}
                      value={status}
                      label={'Status'}
                      placeholder={'Status'}
                      change={(value: any) => setStatus(value)}
                    />
                  </div>
                  <Button
                    color='primary'
                    icon='fa fa-filter'
                    text={i18n.t(`buttons.filter`)}
                    click={() => searchOrders()}
                    btnClass='h-45px'
                  />
                </div>

                <div className='d-flex align-items-center justify-content-between border-bottom border-top py-4 mt-8 fs-4 fw-bold text-gray-800'>
                  <p className='m-0'>{`${i18n.t(`reports.orders_between`)} ${toDate(
                    startDate
                  )} até ${toDate(finalDate)}`}</p>
                </div>
              </div>
              <Datatable data={orders} headers={header} options={options} color='primary' />
              <div className='w-100 mt-5 d-flex justify-content-end'>
                <Button
                  color='primary'
                  size='small'
                  text={i18n.t(`reports.change_multiple_status`)}
                  click={() => {
                    const items: any = document.getElementsByClassName('checkbox-order')
                    let haveItem = 0
                    if (items && items.length > 0) {
                      for (let i = 0; i < items.length; i++) {
                        if (items[i].checked) {
                          haveItem++
                        }
                      }
                    }
                    if (limitOrderChange && haveItem > limitOrderChange) {
                      Swal.fire({
                        icon: 'error',
                        text: `Máximo de ${limitOrderChange} pedidos para alterar, você selecionou ${haveItem}`,
                      })
                    } else if (haveItem > 0) {
                      setTypeModal('change')
                      showWrapperModal(i18n.t(`reports.change_multiple_status`))
                    } else {
                      Swal.fire({
                        icon: 'error',
                        text: 'Antes é necessário selecionar um pedido',
                      })
                    }
                  }}
                />
              </div>
            </div>
          </div>
          <ModalWrapper
            width={80}
            maxWidth={typeModal === 'print' ? false : true}
            shouldCloseModal={false}
            noCloseOverlay={isPrinting}
            isFooterFixed={typeModal === 'print'}
            confirmAction={
              typeModal === 'cancel'
                ? () => cancelOrder()
                : typeModal === 'change'
                  ? () => {
                    changeMultipleStatus()
                  }
                  : typeModal === 'print'
                    ? printData
                    : () => { }
            }
            textAction={
              typeModal === 'cancel' ? (
                'Salvar'
              ) : typeModal === 'change' ? (
                i18n.t('reports.change_status')
              ) : typeModal === 'print' && isPrinting ? (
                <Loading height={20} width={20} />
              ) : typeModal === 'print' ? (
                'Imprimir'
              ) : (
                ''
              )
            }
            disableButton={isPrinting}
          >
            {typeModal === 'cancel' && (
              <div className='d-flex justify-content-between align-items-center'>
                <div className='modal-body text-break pt-0'>
                  <div className='d-flex flex-column justify-content-center align-items-center w-100 mt-2 px-10'>
                    <KTSVG
                      path='/media/icons/duotune/general/gen044.svg'
                      className={`svg-icon`}
                      svgClassName={`h-100px w-100px`}
                    />
                    <p className='mt-2'>O pedido selecionado será estornado e cancelado.</p>
                    <p>Deseja mesmo cancelar este pedido ?</p>
                  </div>
                </div>
              </div>
            )}
            {typeModal === 'change' && (
              <div className='d-flex justify-content-between align-items-center'>
                <div className='modal-body text-break pt-0'>
                  <div className='d-flex flex-column w-100 mt-2'>
                    <p className='mt-2'>{i18n.t(`reports.change_status_text`)}</p>
                    <div className='mt-2'>
                      <div className='row mb-2'>
                        <div className='col'>
                          <b>{i18n.t(`reports.order_number`)}</b>
                        </div>
                        <div className='col'>
                          <b>{i18n.t(`reports.date`)}</b>
                        </div>
                        <div className='col'>
                          <b>{i18n.t(`reports.consumer`)}</b>
                        </div>
                        <div className='col'>
                          <b>Status</b>
                        </div>
                      </div>
                      {filterOrdersStatus().map((o) => (
                        <div className='row'>
                          <div className='col'>
                            <span className='text-dark fw-thin w-100'>
                              <div dangerouslySetInnerHTML={{ __html: o.id }} />
                            </span>
                          </div>
                          <div className='col'>
                            <p>{toDateTime(o.created)}</p>
                          </div>
                          <div className='col'>
                            <span className='text-dark fw-thin w-100'>
                              <div dangerouslySetInnerHTML={{ __html: o.customer }} />
                            </span>
                          </div>
                          <div className='col'>
                            <span className='text-dark fw-thin w-100'>
                              <div dangerouslySetInnerHTML={{ __html: o.status }} />
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className='mt-2 w-50'>
                      <Input
                        inputAttr={{
                          type: 'select',
                        }}
                        options={statusOptions.filter((s) => s.value)}
                        value={newStatus}
                        label={'Status'}
                        placeholder={'Status'}
                        change={(value: any) => setNewStatus(value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            {typeModal === 'print' && (
              <div className='d-flex justify-content-between align-items-center'>
                {/* <div>
                    <div>
                      {printers.length === 0 && (
                        <div className='mt-6 d-flex align-items-center justify-content-between'>
                          <div>
                            <h3>Buscar impressoras próximas</h3>
                          </div>
                          <div>
                            <Button color='dark' text={'Buscar'} click={() => getPrinters()} />
                          </div>
                        </div>
                      )}
                      {printers.length > 0 && (
                        <div>
                          <h3 className='mt-6 pb-2'>Selecione uma Impressora</h3>
                          {printers.map((printer, index) => (
                            <Input
                              key={index}
                              inputAttr={{type: 'radio'}}
                              name='printer'
                              label={printer}
                              id={printer}
                              value={printer}
                              checked={selectedPrinter === printer}
                              change={() => setSelectedPrinter(printer)}
                            />
                          ))}
                        </div>
                      )}
                    </div>
                  </div> */}
                <div className='d-flex flex-column justify-content-center mt-2'>
                  <p className='mt-2'>{i18n.t(`order_print.title`)}</p>
                  <div className='card'>
                    <div className='card-header text-white d-flex align-items-center justify-content-between bg-primary'>
                      <h5 className='mb-0 text-start'>{i18n.t(`order_print.order_details`)}</h5>
                    </div>
                    <div className='card-body'>
                      <ul className='list-unstyled mb-0'>
                        <li className='mb-3'>
                          <strong>Id:</strong> <span className='text-muted'>{selectedItem.id}</span>
                        </li>
                        <li className='mb-3'>
                          <strong>{i18n.t(`order_print.client`)}:</strong>{' '}
                          <span className='text-muted'>
                            {selectedItem.customer.split(' ').slice(0, 2).join(' ')}
                          </span>
                        </li>
                        {/* <li className='mb-3'>
                          <strong>{i18n.t(`order_print.payment`)}:</strong>{' '}
                          <span className='text-muted'>{selectedItem.payment}</span>
                        </li> */}
                        {/* <li className='mb-3'>
                          <strong>{i18n.t(`order_print.created`)}:</strong>{' '}
                          <span className='text-muted'>{selectedItem.created}</span>
                        </li> */}
                        <li className='mb-3'>
                          <strong>Status:</strong>{' '}
                          <span className='text-muted'>{selectedItem.status}</span>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className='mt-4'>
                    <p>{i18n.t(`order_print.information`)}</p>
                  </div>

                  {resultPrint && (
                    <div
                      className={`${resultPrint.success ? styles.successLog : styles.errorLog
                        } mt-8`}
                    >
                      <svg
                        width='50'
                        height='50'
                        viewBox='0 0 20 20'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M9.6875 2.82031L1.95312 15.5156C1.875 15.6328 1.875 15.7109 1.875 15.8281C1.875 16.1406 2.10938 16.375 2.42188 16.375H17.5391C17.8516 16.375 18.125 16.1406 18.125 15.8281C18.125 15.7109 18.0859 15.6328 18.0078 15.5156L10.2734 2.82031C10.2344 2.70312 10.1172 2.625 10 2.625C9.84375 2.625 9.76562 2.70312 9.6875 2.82031ZM8.08594 1.84375C8.47656 1.17969 9.21875 0.75 10 0.75C10.7422 0.75 11.4844 1.17969 11.875 1.84375L19.6094 14.5391C19.8438 14.9297 20 15.3594 20 15.8281C20 17.1562 18.9062 18.25 17.5391 18.25H2.42188C1.09375 18.25 0 17.1562 0 15.8281C0 15.3594 0.117188 14.9297 0.351562 14.5391L8.08594 1.84375ZM11.25 13.875C11.25 14.5781 10.6641 15.125 10 15.125C9.29688 15.125 8.75 14.5781 8.75 13.875C8.75 13.2109 9.29688 12.625 10 12.625C10.6641 12.625 11.25 13.2109 11.25 13.875ZM10.9375 6.6875V10.4375C10.9375 10.9844 10.5078 11.375 10 11.375C9.45312 11.375 9.0625 10.9844 9.0625 10.4375V6.6875C9.0625 6.17969 9.45312 5.75 10 5.75C10.5078 5.75 10.9375 6.17969 10.9375 6.6875Z'
                          fill={resultPrint.success ? '#67BF5F' : '#EB5353'}
                        />
                      </svg>

                      <p
                        className='mt-2'
                        style={{ color: resultPrint.success ? '#67BF5F' : '#EB5353' }}
                      >
                        {resultPrint.message}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            )}
          </ModalWrapper>
        </div>
      )}
    </>
  )
}

const Pedidos: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          { title: 'Dashboard', path: 'dashboard', isActive: true },
          { title: i18n.t(`reports.order_report`), path: 'order/saleorder', isActive: true },
        ]}
      >
        {i18n.t(`reports.order_report`)}
      </PageTitle>
      <PedidosContent />
    </>
  )
}

export { Pedidos }
